import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type OrgTimeEntryIssue =
  RouterOutputs["timeEntry"]["getTimeEntryIssuesForOrg"][number];

export interface TimeEntryIssueFilters {
  weekKey?: string;
  facilityId?: string;
  providerSearch?: string;
}

export function useTimeEntryIssues(
  organizationBusinessUnitId: string | undefined,
  filters: TimeEntryIssueFilters = {},
) {
  const trpc = useTRPC();

  const {
    data: issues,
    isLoading,
    error,
    refetch,
  } = useQuery(
    trpc.timeEntry.getTimeEntryIssuesForOrg.queryOptions(
      {
        organizationBusinessUnitId: organizationBusinessUnitId!,
        weekKey: filters.weekKey,
        facilityId: filters.facilityId,
        providerSearch: filters.providerSearch,
      },
      {
        enabled: !!organizationBusinessUnitId,
        refetchInterval: 30_000,
      },
    ),
  );

  return {
    issues: issues ?? [],
    isLoading,
    error,
    refetch,
  };
}
